import type { MaterialCategoryType } from '@/constants';
import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import type { GfMaterialList } from '../types';

/** タイプ別APIの category_name（all は全カテゴリ対象） */
export type MaterialCategoryNameForApi = MaterialCategoryType | 'all';

export type GfMaterialsByTypeParams = {
  gfWorkId: number;
  categoryName: MaterialCategoryNameForApi;
  limit: number;
  lastMaterialId?: number;
  direction: 'next' | 'prev';
  tagIds?: number[];
  gfProductId?: number;
};

export type GfMaterialsByTypeResponse = APIResponse<GfMaterialList>;

export const getMaterialsByType = async (params: GfMaterialsByTypeParams) => {
  return await http<GfMaterialsByTypeResponse>('/user/v1/gf/materials/type', {
    method: 'GET',
    query: {
      gf_work_id: params.gfWorkId,
      category_name: params.categoryName,
      limit: params.limit,
      direction: params.direction,
      last_material_id: params.lastMaterialId,
      tag_ids: params.tagIds,
      gf_product_id: params.gfProductId,
    },
  });
};
